module.exports = __webpack_public_path__ + "img/img-publicidad-negocio.0a214886.webp";